export const RESET_PREDEFINED_MESSAGES = "RESET_PREDEFINED_MESSAGES";
export const RESET_PREDEFINED_MESSAGE = "RESET_PREDEFINED_MESSAGE";
export const RESET_ERROR = "PREDEFINED_MESSAGES_RESET_ERROR";

export const GET_PREDEFINED_MESSAGES = "GET_PREDEFINED_MESSAGES";
export const SET_PREDEFINED_MESSAGES = "SET_PREDEFINED_MESSAGES";

export const API_ERROR = "PREDEFINED_MESSAGES_API_ERROR";

export const GET_PREDEFINED_MESSAGE = "GET_PREDEFINED_MESSAGE";
export const SET_PREDEFINED_MESSAGE = "SET_PREDEFINED_MESSAGE";

export const EDIT_PREDEFINED_MESSAGE = "EDIT_PREDEFINED_MESSAGE";
export const EDIT_PREDEFINED_MESSAGE_SUCCESS = "EDIT_PREDEFINED_MESSAGE_SUCCESS";

export const CREATE_PREDEFINED_MESSAGE = "CREATE_PREDEFINED_MESSAGE";
export const CREATE_PREDEFINED_MESSAGE_SUCCESS = "CREATE_PREDEFINED_MESSAGE_SUCCESS";

export const DELETE_PREDEFINED_MESSAGE = "DELETE_PREDEFINED_MESSAGE";
export const DELETE_PREDEFINED_MESSAGE_SUCCESS = "DELETE_PREDEFINED_MESSAGE_SUCCESS";

export const GET_PREDEFINED_MESSAGES_CONVERSATION = "GET_PREDEFINED_MESSAGES_CONVERSATION";
export const GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS = "GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS";
export const GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR = "GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR";
